import FindAccount from 'features/auth/resetPassword/screens/FindAccount/FindAccount';
import React from 'react';

export default function Page() {
  return <FindAccount />;
}
